import { WishlistWidgetLoader } from "../../remote/index.js";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import useAlternativeFaresParams from "../../../hooks/useAlternativeFaresParams.js";
import useClientCachedURL from "../../../hooks/useClientCachedURL.js";
import useProfiler from "../../../hooks/useProfiler.js";
import React from "react";
import { useParams } from "react-router-dom";
import { SearchPaginationDesktop } from "../SearchPagination/index.js";
const SearchResultsContentDesktop = ({ children, fetchedAt }) => {
    const { airports } = useParams();
    const { cacheLastSuccessfulSearchUrl } = useClientCachedURL();
    const { setAlternativeFaresParams } = useAlternativeFaresParams();
    const { isLoggedInAuthLow } = useProfiler();
    cacheLastSuccessfulSearchUrl(airports);
    fetchedAt && setAlternativeFaresParams("searchedAt", fetchedAt);
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement(SearchPaginationDesktop, null),
        isLoggedInAuthLow() && !isFeatureRunningClientSide("FLIGHTS_WEB_WISHLIST_WIDGET_DESKTOP_SSR") ? (React.createElement(WishlistWidgetLoader, null)) : undefined));
};
export default SearchResultsContentDesktop;
